import { render, staticRenderFns } from "./purforecast.vue?vue&type=template&id=164ab13e&scoped=true&"
import script from "./purforecast.vue?vue&type=script&lang=js&"
export * from "./purforecast.vue?vue&type=script&lang=js&"
import style0 from "./purforecast.vue?vue&type=style&index=0&id=164ab13e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164ab13e",
  null
  
)

export default component.exports